import remark from "remark";
import html from "remark-html";

export const Markdown = {
  toHtml: async (markdown: string): Promise<any> => {
    let result = await remark().use(html).process(markdown);
    return String(result);
  },
};
